
import { useEffect, useState } from "react";
import { Card, Col, Button, Row } from "react-bootstrap";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useOrder } from "../hooks/useOrder";

const HistoryTransactionsTabs = () => {
    const { fetchOrders, order } = useOrder();
    const [getOrder, setGetOrder] = useState()

    const [expandedOrders, setExpandedOrders] = useState({});

    useEffect(() => {
        fetchOrders()
    }, [fetchOrders]);


    // Function to toggle expand/collapse state
    const toggleExpand = (orderId) => {
        setExpandedOrders((prevState) => ({
            ...prevState,
            [orderId]: !prevState[orderId],
        }));
    };

    return (
        <Row>
            {order
                .filter(order => order.xendit_status === "PAID")
                .map(order => (
                    <Col key={order.id} md={12} className="mb-2">
                        <Card className="shadow-sm">

                            {/* Clickable Header */}
                            <Card.Header
                                className="bg-success text-white d-flex justify-content-between align-items-center"
                                style={{ cursor: "pointer" }}
                                onClick={() => toggleExpand(order.id)}
                            >
                                <strong>Order #{order.id}</strong>
                                <span>{expandedOrders[order.id] ? <MdKeyboardArrowUp size={27} /> : <MdKeyboardArrowDown size={27} />}</span>
                            </Card.Header>

                            {/* Expandable Order Details */}
                            {expandedOrders[order.id] && (
                                <Card.Body>
                                    {order?.productOrder?.length > 0 ? (
                                        order.productOrder.map(item => (
                                            <div
                                                key={item.id}
                                                className="d-flex align-items-center mb-1 pb-2 border-bottom"
                                                style={{ borderBottom: "1px solid #ddd" }}
                                            >
                                                <img
                                                    src={item.product?.image || "logo512.png"}
                                                    alt={item.product?.name || "Product"}
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        marginRight: "10px",
                                                        borderRadius: "5px",
                                                        border: "1px solid #ddd",
                                                    }}
                                                />
                                                <div className="flex-grow-1">
                                                    <p className="mb-0" style={{ fontSize: 10 }}>{item.product?.name || "Unknown Product"}</p>
                                                    <small style={{ fontSize: 10 }}>Qty: {item.qty || 0}</small>
                                                    <p className="mb-0" style={{ fontSize: 10 }}>
                                                        Rp. {item.product?.starting_price * (item.qty || 0)}
                                                    </p>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>No items in this order.</p>
                                    )}
                                </Card.Body>
                            )}

                            {/* Order Footer */}
                            <Card.Footer className="d-flex justify-content-between align-items-center">
                                <strong>Total: Rp. {order.total_payment || 0}</strong>
                                {/* <Button variant="warning" size="sm">Buy Again 🛒</Button> */}
                            </Card.Footer>
                        </Card>
                    </Col>
                ))}
        </Row>
    );
}

export default HistoryTransactionsTabs;
